import { render, staticRenderFns } from "./dashboardReport.vue?vue&type=template&id=4c7c46a1&scoped=true&"
import script from "./dashboardReport.vue?vue&type=script&lang=js&"
export * from "./dashboardReport.vue?vue&type=script&lang=js&"
import style0 from "./dashboardReport.vue?vue&type=style&index=0&id=4c7c46a1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c7c46a1",
  null
  
)

export default component.exports